module.exports = __webpack_public_path__ + "static/img/icon-ecommerce.7e7cc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-ecommerce.png
// module id = jlvB
// module chunks = 1